import useStreamingMessageRequest from './useStreamingMessageRequest';

const useCreateGenericMessage = (taskId?: string) => {
  const streamingMessageRequest = useStreamingMessageRequest();

  return async (
    prompt: any,
    onReceiveTextChunk: (chunk: string) => void,
    onReceiveToolCall: (name: string) => void,
  ): Promise<void> => {
    if (!taskId) throw new Error('Missing task ID');

    return streamingMessageRequest(
      'createGenericTaskMessage',
      taskId,
      prompt,
      onReceiveTextChunk,
      onReceiveToolCall,
    );
  };
};

export default useCreateGenericMessage;
